import { render, staticRenderFns } from "./VlModalParticipant.vue?vue&type=template&id=6da64338&"
import script from "./VlModalParticipant.vue?vue&type=script&lang=js&"
export * from "./VlModalParticipant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports